export default "/_next/static/0acb9f9aca30adefcebbb569ba01a196.png";